import React, { useState, useRef, useEffect, useLayoutEffect, useCallback } from "react";
import "./style.scss";
import classNames from "classnames";
import { mobileIs, getOverallSettingsClasses } from "../../utils/siteUtils";
import { preloadSth } from '../../utils/dom';
import { Icon, Image } from "../../elements";
import BodyText from "../../elements/body-text";
import { gtag } from "../../utils";
import Videojs from "../video-js";
import Swiper, { Thumbs, FreeMode } from "swiper";
Swiper.use([Thumbs, FreeMode]);

const VideoSwitch = props => {
  const { fields, rendering, lang, page } = props;
  const { items, play_icon, pause_icon } = fields;
  const isAR = page?.fields?.rtl?.value;
  const isMobile = mobileIs();

  const [swiperActiveIndex, setSwiperActiveIndex] = useState(0);

  const mainEl = useRef(null);
  const swiperEl = useRef(null);
  const swiper = useRef(null);
  const paginationSwiperEl = useRef(null);
  const paginationSwiper = useRef(null);
  const rootId = `video-switch__${rendering.uid}`;
  const mainId = `video-switch__main${rendering.uid}`;

  const videoPlay = e => {
    (items || []).map((item, index) => {
      if (!item?.fields.videoNode) return;
      // const { videoIsPlaying } = item?.fields.videoNode.state;
      let playPromise = item.fields.videoNode.player.play();
      if (playPromise !== undefined) {
        playPromise
          .then(_ => {
            if (index !== e?.activeIndex) {
              item.fields.videoNode.player.pause();
            }
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
          });
      }
      return null;
    });
  };
  const animationControl = (item, state = "paused") => {
    let animationEl = isMobile? document.querySelector(`#video-switchItemId__pagination-${item.id}.swiper-slide-active.mobile .video-switch__pagination-item__content-animation`) : document.querySelector(`#video-switchItemId__pagination-${item.id}.swiper-slide-thumb-active .video-switch__pagination-item__content-animation`);
    if (animationEl?.style && animationEl?.style?.animationPlayState !== state) {
      animationEl.style.animationPlayState = state;
    }
  };

  const handleScroll = useCallback(() => {
    if (!mainEl?.current) return;
    const rect = mainEl?.current.getBoundingClientRect();
    const winHeight = window.innerHeight || document.documentElement.clientHeight;
    const inScreen = (rect.top >= 0 && rect.top <= winHeight) || (rect.bottom >= 0 && rect.bottom <= winHeight);
    if (inScreen) {
      setTimeout(() => {
        videoPlay(swiper?.current);
      }, 20);
    }
  });
  const tabItem = (index) => {
    gtag('event', 'Component_info', {
      'component_name': 'VideoSwitch',
      'page_title': page?.name
    });
    if(isMobile){
      setSwiperActiveIndex(index);
      if(isMobile && paginationSwiper.current){
        paginationSwiper.current.slideToLoop(index)
      }
    }
  }
  useLayoutEffect(() => {
    items.forEach((item) => {
      const { video } = item.fields || {};
      const { src, mimeType } = video?.value || {};
      if(src && mimeType) {
        preloadSth(src, mimeType, "video");
      }
    });
  },[]);
  useEffect(() => {
    paginationSwiper.current = new Swiper(paginationSwiperEl.current, {//下面
      enabled: items.length > 1,
      observer: true,
      observeParents: true,
      spaceBetween: 20,
      slidesOffsetBefore: mobileIs() ? 20 : 0,
      slidesPerView: mobileIs() ? "auto" : items.length,
      watchSlidesProgress: true,
      rewind: true,
      on: {
        transitionEnd: function(e) {
          if(swiper.current && isMobile){
            swiper.current.slideToLoop(e?.activeIndex,0)
            videoPlay(e);
          }
        }
      }
    });
    swiper.current = new Swiper(swiperEl.current, {//上面
      enabled: items.length > 1,
      observer: true,
      observeParents: true,
      rewind: isMobile ? false : true,
      thumbs: {
        swiper: isMobile ? null : paginationSwiper.current,
        autoScrollOffset: mobileIs() ? 0 : 1
      },
      on: {
        transitionEnd: function(e) {
          setSwiperActiveIndex(e?.activeIndex);
          if(isMobile){
            paginationSwiper.current.slideToLoop(e?.activeIndex)
          }
          videoPlay(e);
        }
      }
    });
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      swiper.current && swiper.current.destroy(true, true);
      paginationSwiper.current && paginationSwiper.current.destroy(true, true);
    };
  }, []);

  const rootClasses = classNames("video-switch", "grid", getOverallSettingsClasses(fields));

  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
      <div className={"video-switch__main"} id={mainId} ref={mainEl}>
        <div className="swiper video-switch__swiper" ref={swiperEl} dir={isAR ? "rtl" : ""}>
          <div className="swiper-wrapper">
            {(items || []).map((item, index) => {
              const { headingBody, mobile_headingBody, body, mobile_body, poster, video, video_time } = item.fields;
              const itemClasses = classNames("video-switch__item swiper-slide");
              const itemId = `video-switchItemId__${item.id}`;
              const videoOptions =
                video && video.value
                  ? {
                      sources: [
                        {
                          src: video.value.src,
                          type: video.value.mimeType
                        }
                      ],
                      poster: poster.value.src,
                      controls: false,
                      autoplay: { value: true },
                      videoEnded() {
                        swiper.current && swiper.current.slideNext();
                      },
                      videoTimeupdate() {
                        animationControl(item, "running");
                      },
                      videoLoaded() {
                        animationControl(item);
                      },
                      videoPausePressed() {
                        animationControl(item);
                      }
                    }
                  : {};
              return (
                <div id={itemId} className={itemClasses} key={index}>
                  <div className={"video-switch__item-media"}>
                    {video && video.value && <Videojs ref={e => (item.fields.videoNode = e)} {...videoOptions} />}
                    {(!video || !video.value) && <Image className="img" { ... item.fields.poster.value} />}
                    
                  </div>
                </div>
              );
            })}
          </div>
          <div className="video-switch__swiper__pagination swiper-pagination" />
        </div>
        <div className="swiper video-switch__pagination-swiper" ref={paginationSwiperEl} dir={isAR ? "rtl" : ""}>
          <div className="swiper-wrapper">
            {(items || []).map((item, index) => {
              const { headingBody, mobile_headingBody, video_time } = item.fields;
              const itemClasses = classNames("video-switch__pagination-item swiper-slide",isMobile ? 'mobile' : '');
              const itemId = `video-switchItemId__pagination-${item.id}`;
              let animationTime = video_time?.value > 1000 && !mobileIs() ? Number(video_time?.value) + 1000 : video_time?.value || 0;
              const styles = { animationDuration: `${animationTime}s` };
              let headingValue = mobileIs() ? mobile_headingBody : headingBody;
              return (
                <div id={itemId} className={itemClasses} key={index} onClick={e=>tabItem(index)}>
                  <div className="video-switch__pagination-item__content">
                    <Icon className={"video-switch__pagination-item__content__icon play_icon"} icon={play_icon.value} />
                    <Icon className={"video-switch__pagination-item__content__icon pause_icon"} icon={pause_icon?.value} />
                    <BodyText className={"video-switch__pagination-item__content__text"} html={headingValue} />
                  </div>
                  <p style={styles} className="video-switch__pagination-item__content-animation"></p>
                </div>
              );
            })}
          </div>
          <div className="video-switch__swiper__pagination swiper-pagination" />
        </div>
        <div className={"video-switch__swiper__texts"}>
          {(items || []).map((item, index) => {
            const { body, mobile_body } = item.fields;
            let bodyValue = mobileIs() ? mobile_body : body;
            const textsClasses = classNames("video-switch__swiper__text", { active: index === swiperActiveIndex });
            return (
              <div className={textsClasses} key={index}>
                <BodyText className={"video-switch__item-main__title-body"} html={bodyValue} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default VideoSwitch;
